/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import "./global/global.css";
import Header from "./global/components/Header";
import DashboardCards from "./global/components/DashboardCards";

import MenuList from "./assets/menuList.png";
import CheckList from "./assets/tick.png";
import Msg from "./assets/msg.png";
import NotificationCards from "./global/components/NotificationCards";
import {
  addLinkedAccount,
  fetchDashboardData,
  clearDashboardError,
} from "../../actions/addLinkedAccounts.js";
import { connect } from "react-redux";
import axios from "axios";

// import ReceivedIcon from "./assets/received.png";
import ReceivedIconG from "./assets/receivedG.png";

// import ProofOfFundsOpenIcon from "./assets/msgOpen.png";
import ProofOfFundsOpenIconG from "./assets/msgOpenG.png";

// import ProofOfFundsSentIcon from "./assets/msgTick.png";
import ProofOfFundsSentIconG from "./assets/msgTickG.png";

// import MessgaeReplyIcon from "./assets/msgList.png";
import MessgaeReplyIconG from "./assets/msgListG.png";

import { usePlaidLink } from "react-plaid-link";
import SideBar from "./global/components/SideBar.js";
import BellIcon from "./assets/bellIcon.png";
import NoNotifications from "./assets/noti.png";
import useWindowSize from "./global/hooks/WindowResizer.js";
import MobileViewHeader from "./global/components/MobileViewHeader.js";

const dashBoardCardData = [
  {
    icon: MenuList,
    title: "Request Proof of Funds",
    link: "/requestreport",
    subText: "Initiate a request to confirm available funds.",
    isBeta: false,
  },
  {
    icon: CheckList,
    title: "Call List Verification",
    link: "/fastrealty/call_list",
    subText: "Start verifying your call list details now.",
    isBeta: true,
  },
  {
    icon: Msg,
    title: "Generate an Email",
    link: "/fastrealty/magic_emails",
    subText: "Start drafting your email with one click.",
    isBeta: true,
  },
];

const Dashboard = (props) => {
  console.log("props", props);

  const dispatch = props.dispatch;
  const {
    dashboardData,
    dashboardDataLoading,
    dashboardErrorMsg,
    dashboardError,
  } = props;
  const [linkToken, setLinkToken] = useState(null);
  const LS_FIRST_TIME_MODALS = "pvFirstTimeModals";
  const showModalsLocalStorage = localStorage.getItem(LS_FIRST_TIME_MODALS);

  const [showErrorModal, setShowErrorModal] = useState(false);
  const isMobileView = useWindowSize();

  const onSuccess = useCallback(
    (token, metadata) => {
      dispatch(addLinkedAccount(token, metadata));
    },
    [dispatch]
  );

  useEffect(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/create_link_token`
      );
      console.log(response);
      console.log(`link token: ${response.data.link_token}`);
      setLinkToken(response.data.link_token);
    } catch (error) {
      console.log(error);
    }
  }, [setLinkToken]);

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, []);

  const notifications = dashboardData?.events || [];

  //
  const handleClick = () => {
    if (ready) {
      open();
    }
  };

  const config = {
    token: linkToken !== null ? linkToken : "",
    onSuccess,
  };

  const { open, ready, err } = usePlaidLink(config);

  const formatNumbers = (num) => {
    if (num % 1 !== 0) {
      let localeNum = num.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return localeNum;
    } else {
      return num.toLocaleString();
    }
  };

  const handleErrorModalClose = () => {
    setShowErrorModal(false);
    dispatch(clearDashboardError());
  };

  //

  const getNotificationIcon = (msgStatus) => {
    switch (msgStatus) {
      case "Proof-of-funds Request Email Sent.":
        return ProofOfFundsSentIconG;
      case "Proof-of-funds Request Email Opened.":
        return ProofOfFundsOpenIconG;
      case "Proof-of-funds Request sent to Bank":
        return MessgaeReplyIconG;
      case "Proof-of-funds Report received from Bank":
        return ReceivedIconG;
      default:
        return ProofOfFundsSentIconG;
    }
  };

  // Function to render a single notification card
  const renderNotificationCard = (evt, idx) => {
    switch (evt.type) {
      case 1: // message event type
        let msg = evt.message;
        return (
          <NotificationCards
            key={msg.id || idx}
            heading={evt.subject || "New Message"}
            email={msg.to_user}
            time={new Date(msg.message_date).toDateString()}
            icon={getNotificationIcon(msg.message_status)}
          />
        );
      case 2: // call list event type
        const card = (
          <NotificationCards
            key={evt.id || idx}
            heading={evt.subject || "Event Update"}
            sub={evt.body}
            time={new Date(evt.date).toDateString()}
            icon={ReceivedIconG}
            linkURL={`/call-list`}
          />
        );
        return card;
      case 3: // email campaign event type
        return (
          <NotificationCards
            key={evt.id || idx}
            heading={evt.subject || "Event Update"}
            sub={evt.body}
            time={new Date(evt.date).toDateString()}
            icon={ReceivedIconG}
            linkURL={`/call-list`}
          />
        );
      default:
        console.log("evt.type does not match any case", evt.type);
        return null;
    }
  };

  return (
    <>
      <div className="dashboard-root">
        {/* <Header /> */}

        <div className="db-container">
          {/* {!isMobileView && (
            <div className="bell">
              <img src={BellIcon} alt="bellIcon" className="belli" />
            </div>
          )}


          {isMobileView && <MobileViewHeader />} */}

          {/* <Header /> */}

          <div className="dashboard">
            <div className="dashboard-container">
              <div className="dashboard-content">
                <h3>Dashboard</h3>
                <p>
                  <span style={{ color: "#707070" }}>
                    Centralize your tasks
                  </span>{" "}
                  — request funds, send emails, and calculate ROI—{" "}
                  <span style={{ color: "#707070" }}>all from here.</span>
                </p>
              </div>
              <div className="dashboard-cards-list">
                {dashBoardCardData.map((card, index) => (
                  <DashboardCards
                    key={index}
                    icon={card.icon}
                    title={card.title}
                    link={card.link}
                    pdr={index === dashBoardCardData.length - 1 ? "pdr" : ""}
                    subText={card?.subText}
                    isBeta={card?.isBeta}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="n" style={{ paddingBottom: "45px" }}>
            <div className="notifications">
              <h3>Notifications</h3>
              <div className="count-box">
                <p>{notifications.length}</p>
              </div>
            </div>
            {/* <NotificationCards /> */}

            <div className="not-card-list-container">
              {notifications.length > 0 ? (
                notifications.map(renderNotificationCard)
              ) : (
                <div className="no-not">
                  <img
                    src={NoNotifications}
                    alt="no-notifications"
                    style={{ height: "250px", width: "319px" }}
                  />
                  <p
                    style={{ paddingLeft: "1rem", color: "black" }}
                    className="no-notifications"
                  >
                    No notifications found.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// export default Dashboard;
export default connect((state) => ({
  dashboardData: state.dashboardData,
  dashboardDataLoading: state.dashboardDataLoading,
  dashboardErrorMsg: state.dashboardErrorMsg,
  dashboardError: state.dashboardError,
}))(Dashboard);
